import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=b4327342&scoped=true&"
import script from "./MenuProduct.vue?vue&type=script&lang=js&"
export * from "./MenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./MenuProduct.vue?vue&type=style&index=0&id=b4327342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4327342",
  null
  
)

export default component.exports